module.exports = __webpack_public_path__ + "img/fainari-marker_en.65846c8b.png";